import BladePatternGuide from "./BladePatternGuide";
export default BladePatternGuide;
